<template>
  <v-row class="fill-height">
    <v-col>
      <v-sheet height="64">
        <v-toolbar flat>
          <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">
            Hoje
          </v-btn>
          <v-btn fab text small color="grey darken-2" @click="prev">
            <v-icon small> mdi-chevron-left </v-icon>
          </v-btn>
          <v-btn fab text small color="grey darken-2" @click="next">
            <v-icon small> mdi-chevron-right </v-icon>
          </v-btn>
          <v-toolbar-title v-if="$refs.calendar">
            {{ $refs.calendar.title }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-menu bottom right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on">
                <span>{{ typeToLabel[type] }}</span>
                <v-icon right> mdi-menu-down </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="type = 'day'">
                <v-list-item-title>Hoje</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'week'">
                <v-list-item-title>Semana</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'month'">
                <v-list-item-title>Mês</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = '4day'">
                <v-list-item-title>4 Dias</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar>
      </v-sheet>
      <v-sheet height="600">
        <v-calendar
          locale="pt-BR"
          ref="calendar"
          v-model="focus"
          color="primary"
          :events="events"
          :event-color="getEventColor"
          :type="type"
          @click:event="showEvent"
          @click:more="viewDay"
          @click:date="viewDay"
        ></v-calendar>
        <v-menu
          v-model="selectedOpen"
          :close-on-content-click="false"
          :activator="selectedElement"
          offset-x
        >
          <v-card min-width="350px" flat>
            <v-toolbar :color="selectedEvent.color" dark>
              <v-toolbar-title
                >{{ selectedEvent.name }}
                <v-icon v-if="selectedEvent.confirmed" color="green"
                  >mdi-verified-outlined</v-icon
                ></v-toolbar-title
              >
              <v-spacer></v-spacer>
              <v-menu
                offset-y
                v-if="module === 'professor/curso'"
                :disabled="selectedEvent.color === 'red'"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-on="on" v-bind="attrs">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    ><v-btn plain text @click="setupAulas(selectedEvent)">
                      Opções da aula
                    </v-btn></v-list-item
                  >
                </v-list>
              </v-menu>
              <v-menu
                offset-y
                v-if="module === 'aluno/curso' && !selectedEvent.isGeneralClass"
                :disabled="selectedEvent.color === 'red'"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-on="on" v-bind="attrs">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    ><v-btn plain text @click="modalAdiarAluno(selectedEvent)">
                      Solicitar alteração
                    </v-btn></v-list-item
                  >
                </v-list>
              </v-menu>
            </v-toolbar>
            <v-card-text>
              <v-row class="mt-2" v-if="selectedEvent.description">
                <span class="top">{{ selectedEvent.description }}</span>
              </v-row>
              <v-row class="mt-4" v-if="selectedEvent.isGeneralClass">
                <strong class="top"
                  >Tipo: {{ selectedEvent.generalClassTypeLabel }}</strong
                >
              </v-row>
              <v-row class="mt-4" v-if="selectedEvent.isGeneralClass">
                <strong class="top"
                  >Nivel atendido: {{ selectedEvent.audienceLabel }}</strong
                >
              </v-row>
              <v-row class="mt-4" v-if="selectedEvent.isGeneralClass">
                <strong class="top"
                  >Professor: {{ selectedEvent.teacherName }}</strong
                >
              </v-row>
              <v-row class="mt-4" v-if="selectedEvent.isGeneralClass">
                <strong class="top"
                  >Duracao:
                  {{ formatDuration(selectedEvent.durationInMinutes) }}</strong
                >
              </v-row>
              <v-row class="mt-4" v-if="selectedEvent.isGeneralClass">
                <strong class="top"
                  >Inicio: {{ formatDateTime(selectedEvent.start) }}</strong
                >
              </v-row>
              <v-row
                class="mt-4"
                v-if="
                  selectedEvent.isGeneralClass &&
                  selectedEvent.generalClassType === 'mentoring' &&
                  !selectedEvent.hasMaterial
                "
              >
                <strong class="top">Esta monitoria nao possui material.</strong>
              </v-row>
              <v-row class="mt-4" v-if="!selectedEvent.isGeneralClass">
                <strong class="top"
                  >Código da turma: {{ selectedEvent.code }}</strong
                >
              </v-row>
              <v-row class="mt-4" v-if="!selectedEvent.isGeneralClass">
                <strong class="top"
                  >Nível: {{ showLevel(selectedEvent.level) }}</strong
                >
              </v-row>
              <v-row class="mt-4" v-if="!selectedEvent.isGeneralClass">
                <strong class="top">Participantes: </strong>
              </v-row>
              <v-row class="mt-4" v-if="!selectedEvent.isGeneralClass">
                <v-chip
                  small
                  v-for="(student, index) in selectedEvent.students"
                  :key="index"
                  >{{ student.full_name }}</v-chip
                >
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-btn text color="primary" @click="selectedOpen = false">
                Cancelar
              </v-btn>
              <v-spacer></v-spacer>

              <v-btn
                v-if="selectedEvent.hasMaterial"
                text
                color="primary"
                @click="abrirMaterial(selectedEvent)"
                >Acessar material
              </v-btn>

              <v-btn
                v-if="selectedEvent.link"
                text
                color="primary"
                @click="openLink(selectedEvent.link)"
              >
                Acessar aula
              </v-btn>
              <v-btn
                v-if="
                  module === 'aluno/curso' &&
                  selectedEvent.isGeneralClass &&
                  !selectedEvent.confirmed
                "
                text
                color="primary"
                @click="confirmGeneralClassParticipation(selectedEvent)"
              >
                Vou participar!
              </v-btn>
              <v-btn
                v-if="
                  module === 'aluno/curso' &&
                  selectedEvent.isGeneralClass &&
                  selectedEvent.confirmed
                "
                text
                color="success"
                disabled
              >
                Participacao confirmada
              </v-btn>
              <v-btn
                v-if="module === 'aluno/curso' && selectedEvent.isGeneralClass"
                text
                color="error"
                @click="declineGeneralClassParticipation(selectedEvent)"
              >
                Não participar
              </v-btn>
              <v-btn
                plain
                text
                @click="setupAulas(selectedEvent)"
                v-if="module === 'professor/curso'"
              >
                Opções da aula
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-sheet>
    </v-col>
    <classEditDialog
      ref="dialog"
      :item="focused"
      @confirm="confirmClass"
      @adiar="modalAdiar"
    />
    <adiarAulaDialog ref="adiar" :item="adiando" @confirm="adiarAula" />
    <adiarAulaAlunoDialog
      ref="adiarAluno"
      :item="adiando"
      @confirm="adiarAulaAluno"
    />
  </v-row>
</template>
<script>
import partnerApi from "@/shared/pitchPartnerApi";
import classEditDialog from "./classEditDialog.vue";
import adiarAulaDialog from "./adiarAulaDialog.vue";
import adiarAulaAlunoDialog from "./adiarAulaAlunoDialog.vue";
export default {
  name: "AppCalendar",
  components: { classEditDialog, adiarAulaDialog, adiarAulaAlunoDialog },
  props: {
    items: Array,
  },
  created() {
    if (this.$route.path.includes("professor")) {
      this.module = "professor/curso";
    } else this.module = "aluno/curso";
  },
  watch: {
    items: {
      immediate: true,
      handler(items = []) {
        this.events = items.map((item) => this.mapItemToEvent(item));
      },
    },
  },
  computed: {},
  data: () => ({
    focused: {},
    adiando: {},
    focus: "",
    type: "month",
    typeToLabel: {
      month: "Mês",
      week: "Semana",
      day: "Dia",
      "4day": "4 Dias",
    },
    module: null,
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    events: [], // Inicialmente vazio,
    englishLevels: [
      {
        text: "Beginner 1",
        value: 0,
      },
      {
        text: "Beginner 2",
        value: 1,
      },
      {
        text: "Essential 1",
        value: 2,
      },
      {
        text: "Essential 2",
        value: 3,
      },
      {
        text: "Pre Intermediate 1",
        value: 4,
      },
      {
        text: "Pre Intermediate 2",
        value: 5,
      },
      {
        text: "Intermediate 1",
        value: 6,
      },
      {
        text: "Intermediate 2",
        value: 7,
      },
      {
        text: "Upper 1",
        value: 8,
      },
      {
        text: "Upper 2",
        value: 9,
      },
      {
        text: "Advanced 1",
        value: 10,
      },
      {
        text: "Advanced 2",
        value: 11,
      },
    ],
  }),
  methods: {
    mapItemToEvent(item) {
      return {
        id: item.id,
        name: `${item.name}`,
        description: item.description,
        start: this.parseDate(item.start),
        end: this.parseDate(item.end),
        color: item.color,
        timed: true,
        link: item.link,
        confirmed: !!item.participationConfirmed,
        isGeneralClass: !!item.isGeneralClass,
        generalClassId: item.generalClassId || null,
        generalClassType: item.generalClassType || null,
        generalClassTypeLabel: item.generalClassTypeLabel || null,
        audienceLabel: item.audienceLabel || null,
        teacherName: item.teacherName || null,
        durationInMinutes:
          item.durationInMinutes ||
          this.calculateDurationInMinutes(item.start, item.end),
        level: item.level,
        code: item.code,
        students: item.students || [],
        classId: item.classId,
        content: item.content,
        materialLink: item.materialLink || null,
        hasMaterial: item.isGeneralClass
          ? !!(item.content || item.materialLink)
          : !!item.content,
      };
    },
    parseDate(value) {
      if (!value) return null;

      if (value instanceof Date) return value;

      return new Date(String(value).replace(" ", "T"));
    },
    calculateDurationInMinutes(start, end) {
      const parsedStart = this.parseDate(start);
      const parsedEnd = this.parseDate(end);

      if (!parsedStart || !parsedEnd) return null;

      return Math.max(0, Math.round((parsedEnd - parsedStart) / 60000));
    },
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        requestAnimationFrame(() =>
          requestAnimationFrame(() => (this.selectedOpen = true))
        );
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        requestAnimationFrame(() => requestAnimationFrame(() => open()));
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    openLink(url) {
      window.open(url, "_blank");
    },
    confirmGeneralClassParticipation(item) {
      if (!item.generalClassId) return;

      this.selectedOpen = false;
      this.$emit("participate-general-class", item.generalClassId);
    },
    declineGeneralClassParticipation(item) {
      if (!item.generalClassId) return;

      this.selectedOpen = false;
      this.$emit("decline-general-class", item.generalClassId);
    },
    setupAulas(item) {
      this.focused = item;
      this.$refs.dialog.open();
    },
    confirmClass(item) {
      partnerApi.confirmClass(item.id).then(() => {
        this.$root.$emit("display-alert", {
          text: "Aula confirmada com sucesso!",
          type: 0,
        });
      });
      this.$refs.dialog.close();
      this.$emit("reload");
    },
    modalAdiar(item) {
      this.$refs.dialog.close();
      this.adiando = item;
      this.$refs.adiar.open();
    },
    modalAdiarAluno(item) {
      this.adiando = item;
      this.$refs.adiarAluno.open();
    },
    adiarAula(data) {
      this.$refs.adiar.close();
      this.$emit("adiar", data);
    },
    adiarAulaAluno(data) {
      this.$refs.adiarAluno.close();
      this.$emit("adiar", data);
    },
    showLevel(level) {
      if (level !== undefined && level !== null) {
        const currentLevel = this.englishLevels.find(
          (item) => item.value === +level
        );
        if (currentLevel) return currentLevel.text;
      }

      return "Aguardando nivelamento";
    },
    formatDuration(durationInMinutes) {
      if (!durationInMinutes) return "Nao informado";

      const hours = Math.floor(durationInMinutes / 60);
      const minutes = durationInMinutes % 60;

      if (hours && minutes)
        return `${hours}h${minutes.toString().padStart(2, "0")}`;
      if (hours) return `${hours}h`;
      return `${minutes}min`;
    },
    formatDateTime(value) {
      if (!value) return "";

      const date = value instanceof Date ? value : this.parseDate(value);

      if (!date || Number.isNaN(date.getTime())) return "";

      return new Intl.DateTimeFormat("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      }).format(date);
    },
    parseContentReference(content) {
      const normalized = String(content || "").trim();

      if (!normalized) {
        return {
          moduleId: null,
          materialId: null,
        };
      }

      const [moduleId, materialId] = normalized.split("/");

      return {
        moduleId: moduleId || null,
        materialId: materialId || null,
      };
    },
    buildMaterialUrl(content) {
      const { moduleId, materialId } = this.parseContentReference(content);

      if (!moduleId) return null;

      const params = new URLSearchParams();

      if (materialId) {
        params.set("material", materialId);
      }

      if (this.selectedEvent?.link) {
        params.set("classLink", this.selectedEvent.link);
      }

      if (this.module === "professor/curso") {
        const baseUrl = `${window.location.origin}/connect/professor/curso/material/${moduleId}`;
        const query = params.toString();
        return query ? `${baseUrl}?${query}` : baseUrl;
      }

      const baseUrl = `${window.location.origin}/connect/aluno/curso/${moduleId}`;
      const query = params.toString();
      return query ? `${baseUrl}?${query}` : baseUrl;
    },
    abrirMaterial(item) {
      const materialUrl = this.buildMaterialUrl(item.content);

      if (item.isGeneralClass) {
        if (materialUrl) {
          window.open(materialUrl, "_blank");
          return;
        }

        this.openLink(item.materialLink);
        return;
      }

      if (!materialUrl) return;

      window.open(materialUrl, "_blank");
    },
  },
};
</script>

<style scoped>
.top {
  font-size: 1rem;
}
</style>
